// extracted by mini-css-extract-plugin
export default {"wrapper":"LandscapeImageBlockEditPage_wrapper__Shgon"};